__turbopack_context__.v({
  "emptyStateBody": "styles-module__nP-OrG__emptyStateBody",
  "emptyStateContainer": "styles-module__nP-OrG__emptyStateContainer",
  "emptyStateTextContainer": "styles-module__nP-OrG__emptyStateTextContainer",
  "productGrid": "styles-module__nP-OrG__productGrid",
  "segment": "styles-module__nP-OrG__segment",
  "segments": "styles-module__nP-OrG__segments",
  "sixColumns": "styles-module__nP-OrG__sixColumns",
});
